import React,{useState} from 'react'
import '../../sassFiles/mobile/sassPages/loginPagemb.scss'
import {Row,Col, Form} from 'react-bootstrap'
import CommonButton from '../subComponents/CommonButton'
import {Link} from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
const LoginPagemb = () => {
    const [isSubscribed, setIsSubscribed] = useState(false);
  const navigate = useNavigate()

    const [formdata,setFormdata] = useState({
      username:"",
      password:""
    })
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Methods": "*",
    }
    const handleChange = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setIsSubscribed(current => !current);
    };
  
    const handleSubmit=async(e)=>{
      e.preventDefault()
      await LoginUser()
    }
    const handleInput=(e)=>{    
      // setFormdata({...formdata,[e.target.name]: e.target.value} )
    }

    async function LoginUser() {
      try {
        axios.post('https://sass.britishstandardschool.com/api/Auth/Login', {
          username: "anikrahman",
          password: "anik123"
        }, headers)
          .then(function (response) {
            console.log(response);
            if (response.status == 200 && response.title != "Unauthorized") {
              navigate("/teacherdashboard", response);
              //sessionStorage.setItem('jwttoken',response.data)
              window.token = response.data;
            } else {
              formdata.username = "";
              formdata.password = "";
              navigate("/userpassnotmatched");
              localStorage.setItem("authenticated", false);
            }
          })
      } catch (err) {
        if (err) {
          console.error(err);
        }
      }
    }
  return (
    <>
        <div className="mobilecontainer">
            <div className="heading">
                <h4>Login</h4>
            </div>

            <div className="fieldboxforlogin">
                    <Form onSubmit={handleSubmit}>
                      <p>User Name</p>
                      <input type="text" name="username" placeholder='any username' value="" onChange={handleInput}/>
                      <p>password</p>
                      <input type="password" name="password" value="" placeholder="any password" onChange={handleInput}/>

                      <div className="checkboxfull">
                      
                      <input
                        type="checkbox"
                        value={isSubscribed}
                        onChange={handleChange}
                        id="remember"
                        name="subscribe"                        
                      />
                      <span>Remember Me</span>
                    
                      
                      </div>

                      <div className="buttonpartlogin">
                        <CommonButton   buttonTitle="Login"/>
                        <Link className="onlytextlink" to="/forgotpassword">Forgot Password?</Link>
                      </div>
                    </Form>
                    
                  </div>
        </div>
    </>
  )
}

export default LoginPagemb